import React, { PureComponent } from "react";
import {
  PieChart,
  Pie,
  Sector,
  Cell,
  ResponsiveContainer,
  Legend,
} from "recharts";
import { rawData } from "../utils/api-urls";
const data = [
  { name: "Group A", value: 400 },
  { name: "Group B", value: 300 },
  { name: "Group C", value: 300 },
];

const COLORS = ["blue", "pink", "orange"];

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
  index,
}) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="white"
      textAnchor={x > cx ? "start" : "end"}
      dominantBaseline="central"
    >
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};

export default class Example extends PureComponent {
  static jsfiddleUrl = "https://jsfiddle.net/alidingling/c9pL8k61/";
  state = {
    genderWiseData: [],
  };
  componentDidMount() {
    this.getStates();
  }

  getStates = async () => {
    const response = await fetch(rawData);
    const data = await response.json();

    let malesCount = data.raw_data.filter((d) => {
      return d.gender === "M";
    });
    let femaleCount = data.raw_data.filter((d) => d.gender === "F");
    let unknownCount = data.raw_data.filter((d) => d.gender === "");
    this.setState({
      genderWiseData: [
        {
          name: "Males",
          value: malesCount.length,
        },
        {
          name: "Females",
          value: femaleCount.length,
        },
        {
          name: "Unidentified",
          value: unknownCount.length,
        },
      ],
    });
  };

  render() {
    const data = this.state.genderWiseData;

    return (
      <ResponsiveContainer width="100%" height={400}>
        <PieChart>
          <Legend verticalAlign="top" height={36} />
          <Pie
            data={data}
            cx={200}
            cy={200}
            labelLine={false}
            label={renderCustomizedLabel}
            outerRadius={150}
            fill="#8884d8"
            dataKey="value"
          >
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={COLORS[index % COLORS.length]}
              />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    );
  }
}
